import mercadolibreStoreOrderReducer from "./mercadolibre/storeOrder";
import optionsReducer from "./options/options";
import { combineReducers } from 'redux';
const AllReducers = combineReducers({
    mercadolibreStoreOrder: mercadolibreStoreOrderReducer,
    options: optionsReducer
})

export default AllReducers;